/**
 * Person-related enums shared between the main app (`src/`) and the
 * voice-agent runtime (`livekit/`). The agent can only import from
 * `packages/shared/`, so any enum that needs to surface in agent code,
 * agent-API request schemas, or LLM tool parameters must live here.
 *
 * `src/models/person.ts` re-exports these to keep existing imports working.
 */

export enum PersonGender {
  MALE = "Male",
  FEMALE = "Female",
  OTHER = "Other",
  UNKNOWN = "Unknown",
}

export enum BinaryPersonGender {
  MALE = PersonGender.MALE,
  FEMALE = PersonGender.FEMALE,
}
